import moment from 'moment-timezone';
import type {List, Map} from 'immutable';

/**
 * Subset of the Teacher meta model methods these extensions rely on. The
 * underlying generated TeacherModel is still untyped JS, so we describe just the
 * dynamic JSON:API meta access used here. `getSchoolLicensesInfo` returns a
 * List of Immutable Maps keyed by string license fields.
 */
interface TeacherMeta {
  getSchoolLicensesInfo(): List<Map<string, unknown>>;
}

/**
 * Shape of the model instance these extensions are mixed into. The extensions
 * rely on methods provided by the base TeacherModel (its Immutable
 * record/JSON:API resource interface).
 */
interface TeacherContext {
  getIn(path: ['meta', 'active_school_license']): boolean;
  getMeta(): TeacherMeta;
}

export default {
  hasActiveSchoolLicense(this: TeacherContext): boolean {
    return this.getIn(['meta', 'active_school_license']);
  },

  getLicenseEndDateForSchool(
    this: TeacherContext,
    schoolId: string
  ): moment.Moment | null {
    const endDate = this.getMeta()
      .getSchoolLicensesInfo()
      .find((item?: Map<string, unknown>) => item?.get('school_id') === schoolId)
      ?.get('school_license_end_date');
    return endDate ? moment(endDate as moment.MomentInput) : null;
  },

  getLicenseStatusForSchool(this: TeacherContext, schoolId: string): unknown {
    const status = this.getMeta()
      .getSchoolLicensesInfo()
      .find((item?: Map<string, unknown>) => item?.get('school_id') === schoolId)
      ?.get('has_school_license');

    return status;
  }
};
